import config from "../../config";

export const SUBSCRIBER_REQUEST = "SUBSCRIBER_REQUEST";
export const SUBSCRIBER_REQUEST_SUCCESS = "SUBSCRIBER_REQUEST_SUCCESS";
export const SUBSCRIBER_REQUEST_FAIL = "SUBSCRIBER_REQUEST_FAIL";

const imageCacheUrl = config.images.cacheUrl;
const imageBaseUrl = config.images.baseUrl;

export const BASE_URL = config.api.baseUrl;
export const IMAGE_CACHE_URL = imageCacheUrl + "/uk_";
export const IMAGE_CACHE_URL_GROUP = imageCacheUrl + "/";
export const IMAGE_CACHE_URL_CATEGORY = imageCacheUrl + "/";
export const IMAGE_CACHE_URL_BANNER = imageCacheUrl + "/";
export const IMAGE_BASE_URL = imageBaseUrl;

export const RAZORPAY_ID = "rzp_test_Jqnl2f66RJ7gft";
export const RAZORPAY_SECRET = "YOIQyXMb3IbNjAsbfzvXqLTv";

export const TEXTLOCAL_KEY = "Njc0NDQ4NDU2YTQ1NmI0ZDY4N2E3OTQ2NjE1NDU4Mzg=";
export const TEXTLOCAL_SENDER = "ASDOCFLQAS";

export const SHOP_NAME = "Aarohfood UK";
export const SHOP_ADDRESS = "Hatfield Town Center";
export const CONTACT_DETAIL = {
  india: {
    caller_no: "+918743870503",
    whatsapp: "+918743870503",
    office_address: "Kort Ward 7, Nichlaul Maharajganj, UP",
    no_reply_email: "noreply@agrocroft.com",
    support_email: "customersupport@agrocroft.com",
  },
  united_kingdom: {
    caller_no: "+4401707269944",
    whatsapp: "+4401707269944",
    office_address: "Town-Center Hatfield",
    no_reply_email: "aarohfood@gmail.com",
    support_email: "arrohfood@gmail.com",
  },
};

export const DEFAULT_CALLER_NO = CONTACT_DETAIL.united_kingdom.caller_no;
export const DEFAULT_WHATSAPP = CONTACT_DETAIL.united_kingdom.whatsapp;
export const DEFAULT_NO_REPLY_EMAIL =
  CONTACT_DETAIL.united_kingdom.no_reply_email;
export const DEFAULT_SUPPORT_EMAIL =
  CONTACT_DETAIL.united_kingdom.support_email;
export const DEFAULT_OFFICE_ADDRESS =
  CONTACT_DETAIL.united_kingdom.office_address;

export const COUNTRY_LIST = {
  india: {
    country: "india",
    currency_name: "₹##INR",
    currency: "₹",
  },
  united_kingdom: {
    country: "united_kingdom",
    currency_name: "£##GBP",
    currency: "£",
  },
};

export const DEFAULT_COUNTRY_NAME = "united_kingdom";
export const DEFAULT_COUNTRY = COUNTRY_LIST.united_kingdom.country;
export const DEFAULT_CURRENCY_NAME = COUNTRY_LIST.united_kingdom.currency_name;
export const DEFAULT_CURRENCY = COUNTRY_LIST.united_kingdom.currency;

export const DEFAULT_MOBILE_LENGTH = 11;
export const DEFAULT_MOBILE_PREFIX = "0";

export const DEFAULT_COD_ENABLED = false;
export const DEFAULT_CNC_ENABLED = true; //Click and Collect, pickup at Store
export const DEFAULT_SHIPPING_CHARGE = 1.5;

export const POSTAL_CODES = [
  // {
  //   label: "University of Hertfordshire",
  //   value: "University of Hertfordshire",
  //   dTime: "",
  //   postCode: "AL10",
  //   deliveryEnabled: true,
  // },
  {
    label: "Hatfield",
    value: "hatfield",
    dTime: "",
    postCode: "AL10",
    deliveryEnabled: true,
  },
  {
    label: "Hatfield Business Park",
    value: "hatfield_business_park",
    dTime: "",
    postCode: "AL10",
    deliveryEnabled: true,
  },
  {
    label: "Welwyn Garden City",
    value: "welwyn_garden_city",
    dTime: "",
    postCode: "AL10",
    deliveryEnabled: false,
  },
  {
    label: "Brookmans Park",
    value: "brookmans_park",
    dTime: "",
    postCode: "AL10",
    deliveryEnabled: false,
  },
  {
    label: "Other",
    value: "other",
    dTime: "",
    postCode: "ANY0",
    deliveryEnabled: true,
  },
];
